import React from "react";
import GlobalMetricCards from "../../../../global/GlobalMetricCards";

const AdminDashboardCards = ({ loading, dashboardStats }) => {
  const stats = dashboardStats || {};

  const metricItems = [
    {
      key: "total_calls",
      label: "Total Calls",
      value: stats.total_calls ?? 0,
      tone: "slate",
      chartHeights: [0.4, 0.55, 0.5, 0.65, 0.75],
    },
    {
      key: "incoming_calls",
      label: "Incoming Calls",
      value: stats.incoming_calls ?? 0,
      tone: "teal",
      chartHeights: [0.45, 0.5, 0.35, 0.4, 0.52],
    },
    {
      label: "Outgoing Calls",
      value: stats.outgoing_calls ?? 0,
      tone: "mint",
      chartHeights: [0.5, 0.62, 0.65, 0.75, 0.82],
    },
    {
      key: "pending_follow_ups",
      label: "Pending Follow-ups",
      value: stats.pending_follow_ups ?? 0,
      tone: "coral",
      chartHeights: [0.35, 0.55, 0.7, 0.72, 0.68],
    },
  ];

  return (
    <GlobalMetricCards
      items={metricItems}
      loading={loading}
      skeletonCount={4}
      ariaLabel="Admin call logs statistics"
      gridClassName="gm-metrics-grid--quad"
    />
  );
};

export default AdminDashboardCards;
